import * as React from 'react';

import {Title} from 'shells/typography/title';

import styles from './email-progress-bar-legend.module.css';

type Props = {
    label: string;
    count: number;
    color: string;
};
export function EmailProgressBarLegend({label, count, color}: Props) {
    return (
        <div className={styles.legend}>
            <div style={{backgroundColor: color}} className={styles['key-section']} />
            <Title>{count}</Title>
            <span className={styles.label}>{label}</span>
        </div>
    );
}
